import * as humanizeDuration from 'humanize-duration';

export const timeAgo = (timestamp) => {
  let ms = Date.now() - timestamp;
  return humanizeDuration(ms, { round: true, largest: 1 }) + ' ago';
};
